import * as React from 'react';
import { accentUtils, t } from '../../../../services/HelperService';
import { SummaryCellTemplate, TagCellTemplate } from '../../../grids/GridColumnTemplates';
import {
  CardHeader,
  Chip,
  FileNotesButton,
  MetaRow,
  ProgressBar,
  ReferenceRow,
  isPastDate,
  money,
  shortDate,
  translateKey,
} from './builtInCardParts';

const getPaymentState = (data) => {
  const total = data.TotalIncTax ?? 0;
  const paid = data.Paid ?? 0;
  if (paid <= 0) return { label: t('Unpaid'), tone: 'red' };
  if (total > 0 && paid >= total) return { label: t('Paid in full'), tone: 'green' };
  if (data.HasDeposit) return { label: t('Deposit'), tone: 'amber' };
  return { label: t('Partial'), tone: 'amber' };
};

export const JobBuiltInCard = ({ card, data }) => {
  const isOpen = (data.Status ?? '') === 'status_job_open';
  const eta = data.ETADate ?? data.EstETADate;
  const etaOverdue = isOpen && isPastDate(eta);
  const payment = getPaymentState(data);
  const isHighPriority = (data.Priority ?? '') === 'priority_job_high';

  return (
    <div>
      <CardHeader
        title={data.ContactName || data.CompanyName || card.description}
        repName={data.SalesRepName}
        subTitle={<ReferenceRow reference={data.Reference} linked={data.LinkedReference} />}
      />
      {!accentUtils.isEmpty(data.Products) && (
        <div style={{ marginTop: 6 }}>
          <SummaryCellTemplate value={data.Products} translate />
        </div>
      )}
      {(!accentUtils.isEmpty(data.Tags) || data.CustomStatus || isHighPriority) && (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4, marginTop: 6 }}>
          {data.CustomStatus && <Chip tone="purple">{data.CustomStatus}</Chip>}
          {isHighPriority && <Chip tone="red">{translateKey(data.Priority)}</Chip>}
          {!accentUtils.isEmpty(data.Tags) && <TagCellTemplate value={data.Tags} type="Job" />}
        </div>
      )}
      {eta && (
        <MetaRow icon="schedule" danger={etaOverdue}>
          {t('ETA')} {shortDate(eta)}{etaOverdue ? ` · ${t('overdue')}` : ''}
        </MetaRow>
      )}
      <MetaRow icon="place" right={money(data.TotalIncTax)}>
        {data.Suburb || translateKey(data.Stage)}
      </MetaRow>
      <MetaRow
        icon="payments"
        right={(
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
            {money(data.Paid)}
            <Chip tone={payment.tone}>{payment.label}</Chip>
          </span>
        )}
      >
        {t('Paid')}
      </MetaRow>
      {(data.TotalIncTax ?? 0) > 0 && <ProgressBar ratio={(data.Paid ?? 0) / data.TotalIncTax} />}
      <FileNotesButton entityId={card.entityId} count={data.FileNoteCount} />
    </div>
  );
};
